import { generateId } from '@freelancer/datastore/testing';
import { PoolModel } from './pools.model';

export interface GeneratePoolOptions {
  readonly name: string;
  readonly displayName: string;
  readonly isTalentNetwork: boolean;
  readonly isTestPool: boolean;
}

export function generatePoolObject({
  name,
  displayName,
  isTalentNetwork = false,
  isTestPool = false,
}: GeneratePoolOptions): PoolModel {
  return {
    id: generateId(),
    name,
    displayName,
    isTalentNetwork,
    isTestPool,
  };
}
